import { create } from 'zustand';

interface FactoryWsState {
  connectionStatus: 'disconnected' | 'connecting' | 'connected' | 'error';
  /** Streaming token buffers keyed by runId. Each entry is an ordered list of raw chunk strings. */
  tokenBuffers: Record<string, string[]>;
  /** Current reviewing stage exec ID per run. Set on stage_review, cleared on run end. */
  reviewingStageExecIds: Record<string, string>;

  setConnectionStatus: (s: FactoryWsState['connectionStatus']) => void;
  appendToken: (runId: string, chunk: string) => void;
  clearBuffer: (runId: string) => void;
  getBuffer: (runId: string) => string[];
  setReviewingStageExecId: (runId: string, stageExecId: string) => void;
  clearReviewingStageExecId: (runId: string) => void;
  getReviewingStageExecId: (runId: string) => string | undefined;
}

export const useFactoryWsStore = create<FactoryWsState>((set, get) => ({
  connectionStatus: 'disconnected',
  tokenBuffers: {},
  reviewingStageExecIds: {},

  setConnectionStatus: (connectionStatus) => set({ connectionStatus }),

  appendToken: (runId, chunk) =>
    set((state) => ({
      tokenBuffers: {
        ...state.tokenBuffers,
        [runId]: [...(state.tokenBuffers[runId] ?? []), chunk],
      },
    })),

  clearBuffer: (runId) =>
    set((state) => {
      const next = { ...state.tokenBuffers };
      delete next[runId];
      return { tokenBuffers: next };
    }),

  getBuffer: (runId) => get().tokenBuffers[runId] ?? [],

  setReviewingStageExecId: (runId, stageExecId) =>
    set((state) => ({
      reviewingStageExecIds: { ...state.reviewingStageExecIds, [runId]: stageExecId },
    })),

  clearReviewingStageExecId: (runId) =>
    set((state) => {
      const next = { ...state.reviewingStageExecIds };
      delete next[runId];
      return { reviewingStageExecIds: next };
    }),

  getReviewingStageExecId: (runId) => get().reviewingStageExecIds[runId],
}));
